// extracted by mini-css-extract-plugin
export default {"root":"TimeFilter_root__nXSV8","filter":"TimeFilter_filter__dFlw7","text":"TimeFilter_text__-p22p","active":"TimeFilter_active__DqaqH"};